import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.button !== null)
      setTimeout(() => this.configure(), 0)
  }

  configure() {
    this.buttonOriginalHTML = this.button.innerHTML
    this.buttonOriginalAriaLabel = this.button.getAttribute("aria-label")
    this.buttonSpinnerHTML = `<svg data-controller="spinner" class="h-3/4 m-auto" aria-hidden="true" />`
    this.buttonBlankHTML = ""

    this.form.addEventListener("submit", () => this.toSpinner())
    this.form.addEventListener("turbo:submit-start", () => this.toSpinner())
    this.form.addEventListener("turbo:submit-end", () => this.toButton())
    this.form.addEventListener("spinner:to-spinner", () => this.toSpinner())
    this.form.addEventListener("spinner:to-button", () => this.toButton())
    this.form.addEventListener("spinner:to-blank", () => this.toBlank())
  }

  toSpinner() {
    if (!this.button) return
    this.lockButtonSize()
    this.wasDisabled = this.button.disabled
    this.retainAccessibleName()
    this.button.disabled = true
    this.button.setAttribute("aria-busy", "true")
    this.button.innerHTML = this.buttonSpinnerHTML
  }

  toButton() {
    if (!this.button) return
    this.button.innerHTML = this.buttonOriginalHTML
    this.button.disabled = this.wasDisabled === true
    this.button.removeAttribute("aria-busy")
    this.restoreAccessibleName()
    this.unlockButtonSize()
  }

  toBlank() {
    if (!this.button) return
    this.lockButtonSize()
    this.wasDisabled = this.button.disabled
    this.retainAccessibleName()
    this.button.disabled = true
    this.button.setAttribute("aria-busy", "true")
    this.button.innerHTML = this.buttonBlankHTML
  }

  retainAccessibleName() {
    if (this.buttonOriginalAriaLabel) return

    const name = this.button.innerText?.trim() || this.button.value || "Submitting"
    this.button.setAttribute("aria-label", name)
  }

  restoreAccessibleName() {
    if (this.buttonOriginalAriaLabel) {
      this.button.setAttribute("aria-label", this.buttonOriginalAriaLabel)
    } else {
      this.button.removeAttribute("aria-label")
    }
  }

  lockButtonSize() {
    const rect = this.button.getBoundingClientRect()
    this.button.style.width = `${Math.ceil(rect.width)}px`
    this.button.style.height = `${Math.ceil(rect.height)}px`
  }

  unlockButtonSize() {
    this.button.style.width = ""
    this.button.style.height = ""
  }

  get form() {
    if (this.element.tagName === "FORM")
      return this.element
    else
      return this.element.closest("form")
  }

  get button() {
    if (this.element.type === "submit")
      return this.element
    else
      return this.element.querySelector("button[type=submit]")
  }
}
